import * as React from "react"
import { IconButton, Input, Box, InputGroup, InputLeftElement, InputRightElement } from "@chakra-ui/react"
import { AiOutlineSearch } from "react-icons/ai"
import { GrClose } from "react-icons/gr"

type Props = {
  onSearchSubmit: (search: string) => void
  search: string
}
export const SearchBar = (props: Props) => {
  const [search, setSearch] = React.useState<string>(props.search)
  const handleSubmitSearch = (e: any) => {
    e.preventDefault()
    props.onSearchSubmit(search)
  }

  const handleClearSearch = (e: any) => {
    e.preventDefault()
    props.onSearchSubmit("")
    setSearch("")
  }
  return (
    <Box maxW="400px" as="form" h="40px" onSubmit={handleSubmitSearch} pos="relative">
      <InputGroup>
        <InputLeftElement zIndex={2}>
          <IconButton
            icon={<Box as={AiOutlineSearch} />}
            variant="ghost"
            aria-label="search"
            color="gray.700"
            boxSize="30px"
            minW="30px"
            p={1}
            onClick={handleSubmitSearch}
          />
        </InputLeftElement>
        <Input
          bg="transparent"
          zIndex={1}
          placeholder="Search"
          value={search}
          onChange={(e: any) => setSearch(e.target.value)}
        />
        <InputRightElement>
          <IconButton
            display={!!search ? "block" : "none"}
            icon={<GrClose />}
            variant="ghost"
            aria-label="cancel"
            boxSize="30px"
            minW="30px"
            p={2}
            zIndex={2}
            color="gray.700"
            onClick={handleClearSearch}
          />
        </InputRightElement>
      </InputGroup>
    </Box>
  )
}
